import React, { useState } from 'react';
import { Bar } from 'victory';
import { Portal } from 'react-portal';
import { SimpleTooltip } from 'lib/components/Tooltip/SimpleTooltip';

export const BarWithTooltip = (props) => {
    const { content, datum } = props;
    const TooltipContent = content;

    const [state, setState] = useState({ hover: false });

    const onMouseEnter = (evt) => {
        setState({
            hover: true,
            clientX: evt.clientX,
            clientY: evt.clientY,
        });
    };
    const onMouseLeave = () => {
        setState({
            hover: false,
        });
    };
    const events = {
        onMouseEnter,
        onMouseLeave,
    };

    return (
        <>
            {<Bar {...props} events={events} />}
            {state.hover && (
                <Portal>
                    <SimpleTooltip active left={state.clientX} top={state.clientY}>
                        <TooltipContent data={datum} />
                    </SimpleTooltip>
                </Portal>
            )}
        </>
    );
};
